
function MyCookBookButton() {
    return (
      <div>
        <button className="myCookBookButton">
          📖 Add this recipe to Cookbook
        </button>
      </div>
    );
  }

  export default MyCookBookButton;